import type { IScope } from "angular";

import "angular-translate";
import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import type { IGuardCompany } from "App/Modules/Models/Models/IGuardCompany";
import type { IModalService } from "App/Modules/Services";

export default class GuardCompaniesComponentController {
    public static $inject: string[] = ["$scope", "$translate", "mmModalService"];

    public site: IResponseWithLoading<ISite>;

    public isLoading: boolean;

    public subCaption: string;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: ng.translate.ITranslateService,
        private readonly modalService: IModalService,
    ) {}

    public $onChanges() {
        if (this.site && this.site.data) {
            this.subCaption = this.site.data.guardCompanies.map((gc) => gc.name).join(",");
            this.isLoading = false;
        } else {
            this.isLoading = true;
        }
    }

    public editGuardCompanies(guardCompanies: IGuardCompany[]) {
        this.modalService
            .open<IGuardCompany[], ISite>("mmEditSiteGuardCompanies", guardCompanies, this.site.data)
            .subscribe((editResponse) => {
                this.site.data.guardCompanies = editResponse;
                this.subCaption = this.site.data.guardCompanies.map((gc) => gc.name).join(",");
            });
    }
}
